<template>
  <div
    class="confirm"
    :class="{ 'confirm-isDisabled': disabled }"
    :style="{ width }"
    @click.stop="emitEvent($event)"
  >
    {{ text }}
  </div>
</template>
<script>
export default {
  name: "ConfirmButton",
  props: {
    text: {
      type: String,
      default: "Confirm"
    },
    width: {
      type: String,
      default: "210px"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitEvent(event) {
      if (this.disabled) {
        return;
      }
      this.$emit("onConfirm");
    }
  }
};
</script>
<style>
.confirm {
  align-items: center;
  background: var(--component_modals_common_confirmButton_confirm_background);
  border: var(--component_modals_common_confirmButton_confirm_border);
  border-radius: var(
    --component_modals_common_confirmButton_confirm_border-radius
  );
  color: var(--component_modals_common_confirmButton_confirm_color);
  display: flex;
  font-family: var(--component_modals_common_confirmButton_confirm_font-family);
  font-size: var(--component_modals_common_confirmButton_confirm_font-size);
  height: 65px;
  justify-content: center;
  letter-spacing: 1.84px;
  padding: var(--component_modals_common_confirmButton_confirm_padding);
}
.confirm-isDisabled {
  opacity: 0.1;
}
</style>
